import React, { Component } from 'react';

class Message extends Component {
    render() {
        return (<div className="content-wrapper">
            <div
                style={{
                    background: "#fff3cd",
                    border: "1px solid #ffeeba",
                    padding: "20px",
                    borderRadius: "6px",
                    margin: "20px",
                    fontSize: "16px",
                    textAlign: "center"
                }}
            >
                <h3 style={{ marginBottom: "10px" }}>Important Notice</h3>

                ```
                <p>
                    This website currently supports only the <strong>Sales Module</strong>.
                </p>

                <p>
                    For reports and all other modules, please use our new website.
                </p>

                <p>
                    <strong>New Website:</strong>{" "}
                    <a
                        href="https://web.posible.in"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://web.posible.in
                    </a>
                </p>

                <p>
                    You can log in using the <strong>same credentials</strong> that you
                    currently use on this website.
                </p>

                <a
                    href="https://web.posible.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: "inline-block",
                        marginTop: "10px",
                        padding: "10px 20px",
                        background: "#007bff",
                        color: "#fff",
                        borderRadius: "4px",
                        textDecoration: "none"
                    }}
                >
                    Go to New Website
                </a>
            </div>
        </div>
        );

    }
}

export default Message;
